export default __webpack_public_path__ + "static/media/K2D-ExtraBold.3a1a86bf.ttf";